import { render, staticRenderFns } from "./deposit-form.vue?vue&type=template&id=6d059f93&scoped=true"
import script from "./deposit-form.vue?vue&type=script&lang=js"
export * from "./deposit-form.vue?vue&type=script&lang=js"
import style0 from "./deposit-form.vue?vue&type=style&index=0&id=6d059f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d059f93",
  null
  
)

export default component.exports